export const getProfileSlr = (state) => state.profileReducer.getProfileState; 
export const editProfileSlr = (state) => state.profileReducer.editProfileState; 